export const VIOLATION_CONFIG = {
  // Adult — daily
  MIN_REST_24H:        { label: "Insufficient Daily Rest",                       severity: "error" },
  MAX_WORK_24H:        { label: "Excess Daily Work",                             severity: "error" },
  MIN_CONTINUOUS_REST: { label: "No 6h Continuous Rest Block",                   severity: "error" },
  MAX_REST_SPLITS:     { label: "Too Many Rest Splits",                          severity: "error" },
  MAX_INTERVAL_REST:   { label: "Rest Gap Exceeds 14h",                          severity: "error" },

  // Adult — weekly
  MIN_REST_7D:         { label: "Insufficient Weekly Rest",                      severity: "error" },
  MAX_WORK_7D:         { label: "Excess Weekly Work",                            severity: "error" },

  // Manila exceptions (MLC 2006 / STCW)
  MIN_REST_7D_MANILA_B: { label: "Weekly Rest Below 77h (Exception May Apply)", severity: "warning" },
  MANILA_A_EXCEEDED:    { label: "Manila A Exception Limit Exceeded",            severity: "error" },

  // Young seafarer (16–17)
  YOUNG_NIGHT_WORK:      { label: "Night Work (Under 18)",                       severity: "error" },
  YOUNG_MIN_CONSEC_REST: { label: "No 12h Continuous Rest (Under 18)",           severity: "error" },
  YOUNG_REST_DAYS_7D:    { label: "Missing Rest Days (Under 18)",                severity: "error" },
  YOUNG_BREAK_REQUIRED:  { label: "Break Not Taken After 4.5h Work",            severity: "error" },

  // Under minimum age
  UNDER_MIN_AGE: { label: "Seafarer Under Minimum Age",                          severity: "error" },
};

export const getSeverityColor = (severity) =>
  ({ error: "#D32F2F", warning: "#F57C00" }[severity] ?? "#D32F2F");

/** Ant Design Tag color prop value for a given severity */
export const getSeverityTagColor = (severity) =>
  ({ error: "error", warning: "warning" }[severity] ?? "error");

export const getViolationLabel = (rule) =>
  VIOLATION_CONFIG[rule]?.label ?? rule;

export const getViolationSeverity = (rule) =>
  VIOLATION_CONFIG[rule]?.severity ?? "error";
